export const API_PATH_apiWorkzoneItemSearch = '/services/workzones-management/items/search';
